const DefinedConstant = [
  { name: 'pi', value: '3.14159' },
  { name: 'e', value: '2.71828' },
]

export default DefinedConstant